import { Component, Inject, AfterViewInit, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

declare let SIR: any;

export interface HeadToHeadDialogData {
  matchId: number;
}

@Component({
  selector: 'headtohead-dialog',
  templateUrl: '../sharedTemplates/headtohead-dialog.html',
})
export class HeadToHeadDialog implements AfterViewInit, OnDestroy {
  SIROBJ;

  constructor(public dialogRef: MatDialogRef<HeadToHeadDialog>, @Inject(MAT_DIALOG_DATA) public data: HeadToHeadDialogData) {}

  ngAfterViewInit() {
    this.openHeadToHead();
  }
  ngOnDestroy() {
    this.SIROBJ = null;
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  openHeadToHead() {
    try {
      if (SIR !== undefined) {
        this.SIROBJ = SIR('addWidget', '.sr-widget-h2h', 'headtohead.standalone', { matchId: this.data.matchId });
      }
    } catch (e) {
      console.log(e);
    }
  }
}
